import config from '@/config'

// Mirrors the TabPanel order rendered by OfferTabs.jsx (client/src/features/offers/offer-detail/tabs/OfferTabs.jsx)
// so print-modal tab selections can be translated into the real tab index to switch to for capture.
// Indices 0-7 are always present: Offer Overview, Documents, Legal, Commercial Checklist, Booking,
// Sourcing, GC Material, GCPR. PR, Handover Form, Cost Structure, History and Subsystem tabs follow,
// with PR/Handover Form conditionally present depending on config flags.
export const SOURCING_TAB_INDEX = 5
export const GCPR_TAB_INDEX = 7

const FIXED_TAB_INDEX = {
  offerOverview: 0,
  legal: 2,
  commercialChecklist: 3,
  booking: 4,
  gcMaterial: 6,
  gcpr: GCPR_TAB_INDEX,
}

const getDynamicTabIndexes = () => {
  let index = 8

  let prIndex = null
  if (config.PREnabled) {
    prIndex = index
    index += 1
  }

  let handoverFormIndex = null
  if (config.handoverFormEnabled) {
    handoverFormIndex = index
    index += 1
  }

  const costStructureIndex = index
  index += 1
  const historyIndex = index
  index += 1

  return { prIndex, handoverFormIndex, costStructureIndex, historyIndex, subSystemBaseIndex: index }
}

// Returns the OfferTabs tabIndex a given print-modal tab value corresponds to, or null if it
// doesn't map to a capturable on-screen tab (shouldn't happen for values PrintModal offers).
export const getOfferFormTabIndex = (printTabValue) => {
  if (printTabValue.startsWith('sourcing')) {
    return SOURCING_TAB_INDEX
  }

  if (printTabValue.startsWith('subSystem-')) {
    const subSystemIndex = Number(printTabValue.split('-')[1])
    return getDynamicTabIndexes().subSystemBaseIndex + subSystemIndex
  }

  if (printTabValue in FIXED_TAB_INDEX) {
    return FIXED_TAB_INDEX[printTabValue]
  }

  const { prIndex, handoverFormIndex, costStructureIndex, historyIndex } = getDynamicTabIndexes()

  if (printTabValue === 'pr') return prIndex
  if (printTabValue === 'handoverForm') return handoverFormIndex
  if (printTabValue === 'costStructure') return costStructureIndex
  if (printTabValue === 'history') return historyIndex

  return null
}
